module.exports = __webpack_public_path__ + "img/new-window.65036230.svg";